/** Global comparison switches. Missing settings preserve the enabled experience. */
export const AGENT_BEHAVIOR_KEYS = [
  'agent_readable_replies',
  'agent_content_help',
  'agent_follow_up_restraint',
  'agent_adaptive_consultation',
] as const
export type AgentBehaviorKey = typeof AGENT_BEHAVIOR_KEYS[number]
export type AgentBehaviors = Record<AgentBehaviorKey, boolean>
export type AdminSettingKey = 'show_tool_calls' | AgentBehaviorKey

export function agentBehaviors(settings: Record<string, string>): AgentBehaviors {
  return Object.fromEntries(AGENT_BEHAVIOR_KEYS.map((key) => [key, settings[key] !== 'false'])) as AgentBehaviors
}

export const AGENT_BEHAVIOR_LABELS: Record<AgentBehaviorKey, { title: string; description: string }> = {
  agent_readable_replies: {
    title: 'پاسخ‌های خواناتر',
    description: 'روشن: پاراگراف‌های کوتاه و استفاده به‌جا از فهرست و جدول. خاموش: شیوه معمول پاسخ‌نویسی. نمایش جدول و نمودار در هر دو حالت فعال است.',
  },
  agent_content_help: {
    title: 'کمک کاربردی از منابع افرا',
    description: 'روشن: ارائه نکته یا مثال مفید از منبع مرتبط همراه پیوند. خاموش: معرفی معمول منابع. در هر دو حالت، افرا فقط به محتوای در دسترس استناد می‌کند.',
  },
  agent_follow_up_restraint: {
    title: 'پرهیز از یادآوری تکراری',
    description: 'روشن: پس از یک یادآوری، منتظر پاسخ یا زمان توافق‌شده می‌ماند. خاموش: پیگیری کار عقب‌افتاده با فاصله سه روز. سکوت به معنی انجام کار نیست.',
  },
  agent_adaptive_consultation: {
    title: 'گفت‌وگوی متناسب با مسئله',
    description: 'روشن: سؤال بر اساس ابهام مهم، مصداق واقعی و توضیح‌های جایگزین انتخاب می‌شود. خاموش: راهنمای معمول مشاوره. تأیید فرضیه و قواعد شواهد در هر دو حالت برقرار است.',
  },
}
